var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BasicDialog',{attrs:{"title":_vm.title,"buttonText":_vm.buttonText},on:{"onClose":_vm.onClose,"onSubmit":_vm.goToProfile}},[_c('p',[_vm._v(_vm._s(_vm.content))]),(_vm.mustReconnect)?_c('p',[_vm._v(_vm._s(_vm.mustReconnectContent))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }